module.exports = __webpack_public_path__ + "static/media/concrete.26bf3b71.svg";